// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as ApplyRouteImport } from './routes/apply'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as EmailPreferencesRouteImport } from './routes/email-preferences'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as AuthenticatedActivityRouteImport } from './routes/_authenticated/activity'
import { Route as AuthenticatedCalendarRouteImport } from './routes/_authenticated/calendar'
import { Route as AuthenticatedContactsRouteImport } from './routes/_authenticated/contacts'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedKitsRouteImport } from './routes/_authenticated/kits'
import { Route as AuthenticatedOrganizationsRouteImport } from './routes/_authenticated/organizations'
import { Route as AuthenticatedOutreachRouteImport } from './routes/_authenticated/outreach'
import { Route as AuthenticatedProfileRouteImport } from './routes/_authenticated/profile'
import { Route as AuthenticatedRecruitRouteImport } from './routes/_authenticated/recruit'
import { Route as AuthenticatedSequencesRouteImport } from './routes/_authenticated/sequences'
import { Route as AuthenticatedT1dwpanelRouteImport } from './routes/_authenticated/t1dwpanel'
import { Route as AuthenticatedTimeRouteImport } from './routes/_authenticated/time'
import { Route as EventsIndexRouteImport } from './routes/events.index'
import { Route as EventsSlugRouteImport } from './routes/events.$slug'
import { Route as SpotTokenRouteImport } from './routes/spot.$token'
import { Route as AuthenticatedContactContactIdRouteImport } from './routes/_authenticated/contact.$contactId'
import { Route as AuthenticatedT1dwpanelIndexRouteImport } from './routes/_authenticated/t1dwpanel.index'
import { Route as AuthenticatedT1dwpanelActivityRouteImport } from './routes/_authenticated/t1dwpanel.activity'
import { Route as AuthenticatedT1dwpanelApplicationsRouteImport } from './routes/_authenticated/t1dwpanel.applications'
import { Route as AuthenticatedT1dwpanelAuditRouteImport } from './routes/_authenticated/t1dwpanel.audit'
import { Route as AuthenticatedT1dwpanelCampaignRouteImport } from './routes/_authenticated/t1dwpanel.campaign'
import { Route as AuthenticatedT1dwpanelContactsRouteImport } from './routes/_authenticated/t1dwpanel.contacts'
import { Route as AuthenticatedT1dwpanelEmailTemplatesRouteImport } from './routes/_authenticated/t1dwpanel.email-templates'
import { Route as AuthenticatedT1dwpanelEventsRouteImport } from './routes/_authenticated/t1dwpanel.events'
import { Route as AuthenticatedT1dwpanelKitsRouteImport } from './routes/_authenticated/t1dwpanel.kits'
import { Route as AuthenticatedT1dwpanelLinkAnalyticsRouteImport } from './routes/_authenticated/t1dwpanel.link-analytics'
import { Route as AuthenticatedT1dwpanelNotificationsRouteImport } from './routes/_authenticated/t1dwpanel.notifications'
import { Route as AuthenticatedT1dwpanelNotifyListRouteImport } from './routes/_authenticated/t1dwpanel.notify-list'
import { Route as AuthenticatedT1dwpanelOptOutsRouteImport } from './routes/_authenticated/t1dwpanel.opt-outs'
import { Route as AuthenticatedT1dwpanelOrganizationsRouteImport } from './routes/_authenticated/t1dwpanel.organizations'
import { Route as AuthenticatedT1dwpanelOutreachRouteImport } from './routes/_authenticated/t1dwpanel.outreach'
import { Route as AuthenticatedT1dwpanelProgramsRouteImport } from './routes/_authenticated/t1dwpanel.programs'
import { Route as AuthenticatedT1dwpanelQrAnalyticsRouteImport } from './routes/_authenticated/t1dwpanel.qr-analytics'
import { Route as AuthenticatedT1dwpanelSentryRouteImport } from './routes/_authenticated/t1dwpanel.sentry'
import { Route as AuthenticatedT1dwpanelSequencesRouteImport } from './routes/_authenticated/t1dwpanel.sequences'
import { Route as AuthenticatedT1dwpanelSettingsRouteImport } from './routes/_authenticated/t1dwpanel.settings'
import { Route as AuthenticatedT1dwpanelShirtsRouteImport } from './routes/_authenticated/t1dwpanel.shirts'
import { Route as AuthenticatedT1dwpanelUnmatchedRouteImport } from './routes/_authenticated/t1dwpanel.unmatched'
import { Route as AuthenticatedT1dwpanelVolunteersRouteImport } from './routes/_authenticated/t1dwpanel.volunteers'
import { Route as AuthenticatedT1dwpanelContactContactIdRouteImport } from './routes/_authenticated/t1dwpanel.contact.$contactId'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const ApplyRoute = ApplyRouteImport.update({
            id: '/apply',path: '/apply',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const EmailPreferencesRoute = EmailPreferencesRouteImport.update({
            id: '/email-preferences',path: '/email-preferences',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const AuthenticatedActivityRoute = AuthenticatedActivityRouteImport.update({
            id: '/activity',path: '/activity',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedCalendarRoute = AuthenticatedCalendarRouteImport.update({
            id: '/calendar',path: '/calendar',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedContactsRoute = AuthenticatedContactsRouteImport.update({
            id: '/contacts',path: '/contacts',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedKitsRoute = AuthenticatedKitsRouteImport.update({
            id: '/kits',path: '/kits',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedOrganizationsRoute = AuthenticatedOrganizationsRouteImport.update({
            id: '/organizations',path: '/organizations',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedOutreachRoute = AuthenticatedOutreachRouteImport.update({
            id: '/outreach',path: '/outreach',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedProfileRoute = AuthenticatedProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedRecruitRoute = AuthenticatedRecruitRouteImport.update({
            id: '/recruit',path: '/recruit',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedSequencesRoute = AuthenticatedSequencesRouteImport.update({
            id: '/sequences',path: '/sequences',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedT1dwpanelRoute = AuthenticatedT1dwpanelRouteImport.update({
            id: '/t1dwpanel',path: '/t1dwpanel',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedTimeRoute = AuthenticatedTimeRouteImport.update({
            id: '/time',path: '/time',getParentRoute: () => AuthenticatedRouteRoute
          })
const EventsIndexRoute = EventsIndexRouteImport.update({
            id: '/events/',path: '/events/',getParentRoute: () => rootRouteImport
          })
const EventsSlugRoute = EventsSlugRouteImport.update({
            id: '/events/$slug',path: '/events/$slug',getParentRoute: () => rootRouteImport
          })
const SpotTokenRoute = SpotTokenRouteImport.update({
            id: '/spot/$token',path: '/spot/$token',getParentRoute: () => rootRouteImport
          })
const AuthenticatedContactContactIdRoute = AuthenticatedContactContactIdRouteImport.update({
            id: '/contact/$contactId',path: '/contact/$contactId',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedT1dwpanelIndexRoute = AuthenticatedT1dwpanelIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedT1dwpanelRoute
          })
const AuthenticatedT1dwpanelActivityRoute = AuthenticatedT1dwpanelActivityRouteImport.update({
            id: '/activity',path: '/activity',getParentRoute: () => AuthenticatedT1dwpanelRoute
          })
const AuthenticatedT1dwpanelApplicationsRoute = AuthenticatedT1dwpanelApplicationsRouteImport.update({
            id: '/applications',path: '/applications',getParentRoute: () => AuthenticatedT1dwpanelRoute
          })
const AuthenticatedT1dwpanelAuditRoute = AuthenticatedT1dwpanelAuditRouteImport.update({
            id: '/audit',path: '/audit',getParentRoute: () => AuthenticatedT1dwpanelRoute
          })
const AuthenticatedT1dwpanelCampaignRoute = AuthenticatedT1dwpanelCampaignRouteImport.update({
            id: '/campaign',path: '/campaign',getParentRoute: () => AuthenticatedT1dwpanelRoute
          })
const AuthenticatedT1dwpanelContactsRoute = AuthenticatedT1dwpanelContactsRouteImport.update({
            id: '/contacts',path: '/contacts',getParentRoute: () => AuthenticatedT1dwpanelRoute
          })
const AuthenticatedT1dwpanelEmailTemplatesRoute = AuthenticatedT1dwpanelEmailTemplatesRouteImport.update({
            id: '/email-templates',path: '/email-templates',getParentRoute: () => AuthenticatedT1dwpanelRoute
          })
const AuthenticatedT1dwpanelEventsRoute = AuthenticatedT1dwpanelEventsRouteImport.update({
            id: '/events',path: '/events',getParentRoute: () => AuthenticatedT1dwpanelRoute
          })
const AuthenticatedT1dwpanelKitsRoute = AuthenticatedT1dwpanelKitsRouteImport.update({
            id: '/kits',path: '/kits',getParentRoute: () => AuthenticatedT1dwpanelRoute
          })
const AuthenticatedT1dwpanelLinkAnalyticsRoute = AuthenticatedT1dwpanelLinkAnalyticsRouteImport.update({
            id: '/link-analytics',path: '/link-analytics',getParentRoute: () => AuthenticatedT1dwpanelRoute
          })
const AuthenticatedT1dwpanelNotificationsRoute = AuthenticatedT1dwpanelNotificationsRouteImport.update({
            id: '/notifications',path: '/notifications',getParentRoute: () => AuthenticatedT1dwpanelRoute
          })
const AuthenticatedT1dwpanelNotifyListRoute = AuthenticatedT1dwpanelNotifyListRouteImport.update({
            id: '/notify-list',path: '/notify-list',getParentRoute: () => AuthenticatedT1dwpanelRoute
          })
const AuthenticatedT1dwpanelOptOutsRoute = AuthenticatedT1dwpanelOptOutsRouteImport.update({
            id: '/opt-outs',path: '/opt-outs',getParentRoute: () => AuthenticatedT1dwpanelRoute
          })
const AuthenticatedT1dwpanelOrganizationsRoute = AuthenticatedT1dwpanelOrganizationsRouteImport.update({
            id: '/organizations',path: '/organizations',getParentRoute: () => AuthenticatedT1dwpanelRoute
          })
const AuthenticatedT1dwpanelOutreachRoute = AuthenticatedT1dwpanelOutreachRouteImport.update({
            id: '/outreach',path: '/outreach',getParentRoute: () => AuthenticatedT1dwpanelRoute
          })
const AuthenticatedT1dwpanelProgramsRoute = AuthenticatedT1dwpanelProgramsRouteImport.update({
            id: '/programs',path: '/programs',getParentRoute: () => AuthenticatedT1dwpanelRoute
          })
const AuthenticatedT1dwpanelQrAnalyticsRoute = AuthenticatedT1dwpanelQrAnalyticsRouteImport.update({
            id: '/qr-analytics',path: '/qr-analytics',getParentRoute: () => AuthenticatedT1dwpanelRoute
          })
const AuthenticatedT1dwpanelSentryRoute = AuthenticatedT1dwpanelSentryRouteImport.update({
            id: '/sentry',path: '/sentry',getParentRoute: () => AuthenticatedT1dwpanelRoute
          })
const AuthenticatedT1dwpanelSequencesRoute = AuthenticatedT1dwpanelSequencesRouteImport.update({
            id: '/sequences',path: '/sequences',getParentRoute: () => AuthenticatedT1dwpanelRoute
          })
const AuthenticatedT1dwpanelSettingsRoute = AuthenticatedT1dwpanelSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AuthenticatedT1dwpanelRoute
          })
const AuthenticatedT1dwpanelShirtsRoute = AuthenticatedT1dwpanelShirtsRouteImport.update({
            id: '/shirts',path: '/shirts',getParentRoute: () => AuthenticatedT1dwpanelRoute
          })
const AuthenticatedT1dwpanelUnmatchedRoute = AuthenticatedT1dwpanelUnmatchedRouteImport.update({
            id: '/unmatched',path: '/unmatched',getParentRoute: () => AuthenticatedT1dwpanelRoute
          })
const AuthenticatedT1dwpanelVolunteersRoute = AuthenticatedT1dwpanelVolunteersRouteImport.update({
            id: '/volunteers',path: '/volunteers',getParentRoute: () => AuthenticatedT1dwpanelRoute
          })
const AuthenticatedT1dwpanelContactContactIdRoute = AuthenticatedT1dwpanelContactContactIdRouteImport.update({
            id: '/contact/$contactId',path: '/contact/$contactId',getParentRoute: () => AuthenticatedT1dwpanelRoute
          })





const AuthenticatedT1dwpanelRouteChildren = {
  AuthenticatedT1dwpanelActivityRoute: AuthenticatedT1dwpanelActivityRoute,AuthenticatedT1dwpanelApplicationsRoute: AuthenticatedT1dwpanelApplicationsRoute,AuthenticatedT1dwpanelAuditRoute: AuthenticatedT1dwpanelAuditRoute,AuthenticatedT1dwpanelCampaignRoute: AuthenticatedT1dwpanelCampaignRoute,AuthenticatedT1dwpanelContactsRoute: AuthenticatedT1dwpanelContactsRoute,AuthenticatedT1dwpanelEmailTemplatesRoute: AuthenticatedT1dwpanelEmailTemplatesRoute,AuthenticatedT1dwpanelEventsRoute: AuthenticatedT1dwpanelEventsRoute,AuthenticatedT1dwpanelKitsRoute: AuthenticatedT1dwpanelKitsRoute,AuthenticatedT1dwpanelLinkAnalyticsRoute: AuthenticatedT1dwpanelLinkAnalyticsRoute,AuthenticatedT1dwpanelNotificationsRoute: AuthenticatedT1dwpanelNotificationsRoute,AuthenticatedT1dwpanelNotifyListRoute: AuthenticatedT1dwpanelNotifyListRoute,AuthenticatedT1dwpanelOptOutsRoute: AuthenticatedT1dwpanelOptOutsRoute,AuthenticatedT1dwpanelOrganizationsRoute: AuthenticatedT1dwpanelOrganizationsRoute,AuthenticatedT1dwpanelOutreachRoute: AuthenticatedT1dwpanelOutreachRoute,AuthenticatedT1dwpanelProgramsRoute: AuthenticatedT1dwpanelProgramsRoute,AuthenticatedT1dwpanelQrAnalyticsRoute: AuthenticatedT1dwpanelQrAnalyticsRoute,AuthenticatedT1dwpanelSentryRoute: AuthenticatedT1dwpanelSentryRoute,AuthenticatedT1dwpanelSequencesRoute: AuthenticatedT1dwpanelSequencesRoute,AuthenticatedT1dwpanelSettingsRoute: AuthenticatedT1dwpanelSettingsRoute,AuthenticatedT1dwpanelShirtsRoute: AuthenticatedT1dwpanelShirtsRoute,AuthenticatedT1dwpanelUnmatchedRoute: AuthenticatedT1dwpanelUnmatchedRoute,AuthenticatedT1dwpanelVolunteersRoute: AuthenticatedT1dwpanelVolunteersRoute,AuthenticatedT1dwpanelIndexRoute: AuthenticatedT1dwpanelIndexRoute,AuthenticatedT1dwpanelContactContactIdRoute: AuthenticatedT1dwpanelContactContactIdRoute
}

const AuthenticatedT1dwpanelRouteWithChildren = AuthenticatedT1dwpanelRoute._addFileChildren(AuthenticatedT1dwpanelRouteChildren)



const AuthenticatedRouteRouteChildren = {
  AuthenticatedActivityRoute: AuthenticatedActivityRoute,AuthenticatedCalendarRoute: AuthenticatedCalendarRoute,AuthenticatedContactsRoute: AuthenticatedContactsRoute,AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,AuthenticatedKitsRoute: AuthenticatedKitsRoute,AuthenticatedOrganizationsRoute: AuthenticatedOrganizationsRoute,AuthenticatedOutreachRoute: AuthenticatedOutreachRoute,AuthenticatedProfileRoute: AuthenticatedProfileRoute,AuthenticatedRecruitRoute: AuthenticatedRecruitRoute,AuthenticatedSequencesRoute: AuthenticatedSequencesRoute,AuthenticatedT1dwpanelRoute: AuthenticatedT1dwpanelRouteWithChildren,AuthenticatedTimeRoute: AuthenticatedTimeRoute,AuthenticatedContactContactIdRoute: AuthenticatedContactContactIdRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,ApplyRoute: ApplyRoute,AuthRoute: AuthRoute,EmailPreferencesRoute: EmailPreferencesRoute,ForgotPasswordRoute: ForgotPasswordRoute,PrivacyRoute: PrivacyRoute,ResetPasswordRoute: ResetPasswordRoute,EventsSlugRoute: EventsSlugRoute,SpotTokenRoute: SpotTokenRoute,EventsIndexRoute: EventsIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)